import yup from './yup'
import { checkLeadingAndTrailingSpaces } from 'utils'

export const adminsFormSchema = yup.object().shape({
  fullName: yup
    .string()
    .label('Admin Full Name')
    .trimmedRequired('Admin Full Name is required field.'),
  email: yup.string().email().label('Email').required(),
  password: yup
    .string()
    .min(8)
    .label('Password')
    .test('checkEditPass', 'Password must be at least 8 characters', (value) => {
      if (!value || value.length < 8) {
        return false
      }
      return true
    })
    .test('checkEditPass', 'Password cannot contain leading/trailing spaces', (value) => {
      if (!value || checkLeadingAndTrailingSpaces(value)) {
        return false
      }
      return true
    })
})

export const updatePasswordSchema = yup.object().shape({
  fullName: yup
    .string()
    .label('Admin Full Name')
    .trimmedRequired('Admin Full Name is required field.'),
  newPassword: yup
    .string()
    .label('New Password')
    .test('checkEditPass', 'Password must be at least 8 characters', (value) => {
      if (value && value.length < 8) {
        return false
      }
      return true
    })
    .test('checkEditPass', 'Password cannot contain leading/trailing spaces', (value) => {
      if (value && checkLeadingAndTrailingSpaces(value)) {
        return false
      }
      return true
    })
})

export const userLoginSchema = yup.object().shape({
  email: yup.string().email().label('Email').required(),
  password: yup.string().label('Password').required()
})
